module.exports = __webpack_public_path__ + "static/media/Seam_4631.8971332f.jpg";